export const PETITION_OPTIMIZATION_CALL_URL =
	'https://change.zoom.us/webinar/register/WN_1WuAkn2AStmBsrj2BOxA0A#/registration';
